module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Bold.2a2077c0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Bold.eot
// module id = 91
// module chunks = 3